// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"53":"c0c86a46","156":"5f259e58","364":"5f259e58","611":"c0c86a46"}[chunkId] + ".chunk.css";
};